import React from "react";
import socketio from "socket.io-client";

export const socket = socketio.connect('https://ceo.iosx.in', {
  query: {
    "accesstoken": localStorage.getItem('accesstoken')
  }
});
export const SocketContext = React.createContext();